import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';
import { readMonitoringVersion } from '@cobliteam/monitoring/src/pages/MonitoringGatePage/monitoringVersion';

export const importMonitoringPageV2 = () => import('@cobliteam/monitoring/src/pages/MonitoringPageV2/MonitoringPageV2');
const importMonitoringClassicPage = () => import('@cobliteam/monitoring/src/pages/MonitoringPage');

// Shared with preloadInitialRoute, so a cold load fetches the page chunk in parallel with the boot gates.
// O gate só decide a versão; a página escolhida já baixa junto, senão o clássico esperaria o gate montar.
export const importMonitoringPage = () => {
  const gate = import('@cobliteam/monitoring/src/pages/MonitoringGatePage/MonitoringGatePage');
  void (readMonitoringVersion() === 'v2' ? importMonitoringPageV2() : importMonitoringClassicPage());
  return gate;
};

const MonitoringPage = lazy(importMonitoringPage);
const MonitoringPageV2 = lazy(importMonitoringPageV2);

const routes = [
  {
    title: locationName[Location.MONITORING],
    path: Location.MONITORING,
    team: 'squad-gf-core',
    component: MonitoringPage,
    needsGoogleMaps: true,
  },
  {
    title: locationName[Location.MONITORING_V2],
    path: Location.MONITORING_V2,
    team: 'squad-gf-core',
    component: MonitoringPageV2,
    featureFlag: 'monitoringV2',
    needsGoogleMaps: true,
  },
];

export default routes;
